import React, { useContext, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router'
import Home from '../components/supercut/home'
import Detail from '../components/supercut/detail'
import Message from 'shared/components/message/flash-message'
import CapturePushNotification from '../components/supercut/shared/components/capture-push-notification'
import CreationToolStep from '../types/steps'
import Upload from '../components/upload'
import { SUPERCUT } from './index'
import { CreationToolsContext } from '../manager'
import CreationToolUserRestriction from '../types/user-restriction'

const SupercutRoute = props => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!userRestrictionAccess.length) {
            return
        }

        const isLoggedIn = userRestrictionAccess.includes(CreationToolUserRestriction.LoggedInOnly)
        const hasAccess = userRestrictionAccess.includes(CreationToolUserRestriction.CanAccessSuperCut)

        if (!isLoggedIn) {
            window.location.href = `/login?next=${SUPERCUT}`
        } else if (!hasAccess) {
            window.location.href = '/'
        } else {
            setIsLoading(false)
        }
    }, [userRestrictionAccess])

    return isLoading ? (
        <div />
    ) : (
        <>
            <Message isDesktop />
            <CapturePushNotification />
            <Switch>
                <Route exact path={`${SUPERCUT}`} component={Home} />
                <Route exact path={`${SUPERCUT}/detail/:captureId`} component={Detail} />
                <Route
                    exact
                    path={`${SUPERCUT}${CreationToolStep.route(CreationToolStep.Upload)}`}
                    render={() => <Upload submitUrl={props.submitUrl} apiKey={props.apiKey} />}
                />
            </Switch>
        </>
    )
}

export default SupercutRoute
